/* =========================================================================
   LO QUE DICE UN MENSAJE DE CHAT

   El chat no lleva solo frases: lleva TARJETAS. El pedido que el tendero le
   arma a un cliente viaja como JSON y la app lo pinta como tarjeta con sus
   productos y sus botones.

   El panel tiene que entender ese formato, porque es la MISMA conversación:
   si acá se enseñara el JSON crudo, el tendero vería
   `{"type":"preorder","preorder_id":…}` donde el cliente ve una tarjeta. Es
   exactamente lo que pasaba en la bandeja de avisos de la app antes de
   arreglarlo.

   Esta es la tercera copia de la misma traducción —servidor, app y panel— y
   es deliberado: son tres programas distintos y duplicar seis frases cuesta
   menos que una librería compartida entre PHP, React Native y React.
   ======================================================================== */

/** «$12.400», con punto para los miles. */
const plata = (valor) =>
  typeof valor === "number" && Number.isFinite(valor)
    ? `$${valor.toLocaleString("es-CO", { maximumFractionDigits: 0 })}`
    : null;

/** El JSON de una tarjeta, o null si es texto corriente. */
export function tarjetaDeMensaje(contenido) {
  const texto = String(contenido ?? "").trim();

  if (!texto.startsWith("{")) return null;

  try {
    const datos = JSON.parse(texto);

    return datos && typeof datos.type === "string" ? datos : null;
  } catch {
    return null;
  }
}

const estadoEnPalabras = (estado) => {
  if (estado === "confirmed") return "Confirmó el pedido";
  if (estado === "cancelled") return "Canceló el pedido";

  return "Actualizó el pedido";
};

/**
 * Una línea que resume el mensaje, para la lista de conversaciones.
 *
 * Nunca devuelve JSON: una tarjeta de un tipo que no conocemos cae en una
 * frase neutra, para que el día que alguien añada un tipo nuevo el peor caso
 * sea un resumen pobre y no un volcado de datos.
 */
export function resumenDeMensaje(contenido) {
  const texto = String(contenido ?? "").trim();

  if (texto === "") return "Sin mensajes todavía";

  const tarjeta = tarjetaDeMensaje(texto);

  if (!tarjeta) return texto;

  if (tarjeta.type === "preorder") {
    if ((tarjeta.status ?? "pending") !== "pending") {
      return estadoEnPalabras(tarjeta.status);
    }

    const cuantos = Array.isArray(tarjeta.items) ? tarjeta.items.length : 0;
    const total = plata(tarjeta.total);
    const productos = cuantos === 1 ? "1 producto" : `${cuantos} productos`;

    if (cuantos === 0) return "Pedido armado";

    return total ? `Pedido armado: ${productos} · ${total}` : `Pedido armado: ${productos}`;
  }

  if (tarjeta.type === "preorder_status") return estadoEnPalabras(tarjeta.status);

  return "Mensaje";
}

/** Quién es el otro en una conversación de dos. */
export function elOtro(chat, miUserId) {
  const gente = chat?.participants ?? [];

  return (
    gente.find((p) => Number(p.user_id) !== Number(miUserId)) ?? gente[0] ?? null
  );
}
